<template>
    <section class="ContactBlock" :id=block_id>
        <div class="bg-white">
            <div class="container-block">
                
                <!-- Contact Area -->
                <div class="grid gap-8 md:gap-12 md:grid-cols-2 xl:gap-24">

                    <!-- Text -->
                    <div class="flex flex-col justify-center">

                        <!-- Headline -->
                        <h2 class="mb-4 head-md text-neutral-800">{{ headline }}</h2>

                        <!-- Copy -->
                        <div class="space-y-1 body-sm lg:body-md text-neutral-600 max-w-prose">
                            <p v-for="line in copy" :key="line.id">{{ line }}</p>
                        </div>

                        <!-- Contact -->
                        <div class="flex flex-col items-start mt-6 space-y-2 lg:mt-8">

                            <cta-phone />

                            <cta-email />
                            
                        </div>

                        <div class="mt-6 lg:mt-8">
                            <cta-socials />
                        </div>
                        
                    </div>

                    <!-- Image -->
                    <div class="grid h-full place-items-center">
                        <iframe
                            title="Address Map"
                            class="w-full rounded-lg h-72 lg:h-96 md:rounded-xl" 
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2164.4558781189803!2d-2.1028900840154705!3d57.14636409112003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48840f94c14e57c1%3A0xc468f794a3840f24!2sLatinway!5e0!3m2!1sen!2suk!4v1677020874970!5m2!1sen!2suk"
                            style="border:0;"
                            allowfullscreen=""
                            loading="lazy"
                            referrerpolicy="no-referrer-when-downgrade"
                        ></iframe>
                    </div>

                </div>
                
            </div>
        </div>
    </section>
</template>

<script>

    import CtaPhone from '../components/cta/CtaPhone';
    import CtaEmail from '../components/cta/CtaEmail';
    import CtaSocials from '../components/cta/CtaSocials';

    export default {

        name: 'ContactBlock',

        components: {
            CtaPhone,
            CtaEmail,
            CtaSocials
        },

        props: {
            content: Object, // Hero Content
        },
        
        data(){
            return {
                block_id: this.content.block_id,
                headline: this.content.headline,
                copy: this.content.copy,
                cta: this.content.cta,
                image: this.content.image,
            }
        }
    }

</script>